<template>
  <v-card class="content">
    <v-card-text v-if="experienceScreen">
      <div class="feedback-text">Feedback</div>
      <div class="pb-3">
        <div class="bold subtitle-1">
          Gostaríamos de saber sua opinião após usar o UseCar Frotas.
        </div>
        <div class="bold-subtitle mt-5 mb-2">Sobre a experiência</div>
        <label class="subtitle-1 bold">
          Como foi sua experiência com o serviço?
          <v-rating
            class="text-center"
            medium
            v-model="feedBack.rating"
            background-color="var(--secondary-color)"
            color="var(--secondary-color)"
          ></v-rating>
        </label>
      </div>
    </v-card-text>

    <v-card-text class="dirt-screen" v-if="carDirtScreen">
      <div class="bold-subtitle mt-5 mb-2">
        Sobre o estado interno e externo
      </div>
      <label class="bold subtitle-1">Estado interno do carro:</label>
      <v-radio-group class="mt-0" v-model="feedBack.estadoInterno" col>
        <v-radio label="Limpo" class="cor-secundaria" value="Limpo"></v-radio>
        <v-radio
          label="Pouco sujo"
          class="cor-secundaria"
          value="Pouco sujo"
        ></v-radio>
        <v-radio label="Sujo" class="cor-secundaria" value="Sujo"></v-radio>
        <v-radio
          label="Muito sujo"
          class="cor-secundaria"
          value="Muito Sujo"
        ></v-radio>
      </v-radio-group>
      <label class="bold subtitle-1">Estado externo do carro:</label>
      <v-radio-group class="mt-0" v-model="feedBack.estadoExterno" col>
        <v-radio label="Limpo" class="cor-secundaria" value="Limpo"></v-radio>
        <v-radio
          label="Pouco sujo"
          class="cor-secundaria"
          value="Pouco sujo"
        ></v-radio>
        <v-radio label="Sujo" class="cor-secundaria" value="Sujo"></v-radio>
        <v-radio
          label="Muito sujo"
          class="cor-secundaria"
          value="Muito Sujo"
        ></v-radio>
      </v-radio-group>
      <label class="bold subtitle-1">O carro apresenta algum odor?</label>
      <v-radio-group class="mt-0" v-model="feedBack.odorCarro" row>
        <v-radio label="Sim" class="cor-secundaria" value="sim"></v-radio>
        <v-radio label="Não" class="cor-secundaria" value="não"></v-radio>
      </v-radio-group>
    </v-card-text>

    <v-card-text v-if="carStatusScreen">
      <div class="bold-subtitle">Sobre as condições de uso</div>
      <label class="bold subtitle-1">O carro apresenta algum defeito?</label>
      <v-radio-group
        class="radio-input"
        v-model="feedBack.estadoCarroDefeito"
        :mandatory="false"
        row
      >
        <v-radio value="sim" class="cor-secundaria" label="Sim"></v-radio>
        <v-radio value="não" class="cor-secundaria" label="Não"></v-radio>
      </v-radio-group>
      <v-textarea
        rows="3"
        auto-grow
        v-if="feedBack.estadoCarroDefeito == 'sim'"
        class="cor-secundaria"
        v-model="feedBack.obsDefeitoCarro"
        required
        name="inputestadoCarroDefeito"
        label="Detalhe o defeito encontrado:"
      ></v-textarea>
      <label class="bold subtitle-1"
        >Como você classificaria o estado do carro?</label
      >
      <v-radio-group class="mt-0" v-model="feedBack.estadoGeralCarro" row>
        <span class="regular-font mx-4">Ruim</span>
        <v-radio class="mr-1 cor-secundaria" value="1"></v-radio>
        <v-radio class="mr-1 cor-secundaria" value="2"></v-radio>
        <v-radio class="mr-1 cor-secundaria" value="3"></v-radio>
        <v-radio class="mr-1 cor-secundaria" value="4"></v-radio>
        <v-radio class="mr-1 cor-secundaria" value="5"></v-radio>
        <span class="regular-font">Excelente</span>
      </v-radio-group>

      <v-textarea
        rows="3"
        auto-grow
        class="cor-secundaria"
        v-model="feedBack.obsOutras"
        name="inputLimpesa"
        label="Outras observações:"
      ></v-textarea>
    </v-card-text>

    <v-card-actions style="padding-bottom: 100px">
      <v-btn width="90%" class="white--text continue-btn" @click="nextScreen">
        <span v-if="carStatusScreen">FINALIZAR CHECK-OUT</span>
        <span v-else>CONTINUAR</span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { METHODS } from 'http';
import FeedbackController from './../../controllers/FeedbackController.js';

export default {
  data() {
    return {
      feedbackController: new FeedbackController(this.$resource),
      feedBack: {
        rating: 5,
        estadoInterno: 'Limpo',
        estadoExterno: 'Limpo',
        odorCarro: 'não',
        estadoCarroDefeito: 'não',
        obsDefeitoCarro: 'não',
        estadoGeralCarro: '5',
        obsOutras: '',
      },
      experienceScreen: true,
      carDirtScreen: false,
      carStatusScreen: false,
    };
  },

  methods: {
    nextScreen() {
      if (this.experienceScreen) {
        this.experienceScreen = false;
        this.carDirtScreen = true;
        this.$emit('addProgress', 30);
      } else if (this.carDirtScreen) {
        this.carDirtScreen = false;
        this.carStatusScreen = true;
        this.$emit('addProgress', 30);
      } else if (this.carStatusScreen) {
        this.sendForm();
        this.$router.push('/user/solicitar-reserva');
      }
    },

    sendForm() {
      try {
        this.feedbackController.post(this.feedBack, this.idVehicleRequest);
        this.snackbarColor = 'success';
        this.snackbarText = 'Feedback enviado com sucesso!';
        this.snackbar = true;
      } catch (error) {
        console.log(error);
      }
    },
  },

  props: {
    idVehicleRequest: {
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.blue.darken-1 {
  background-color: var(--primary-color) !important;
}
.v-card__title {
  font-size: 1.5rem;
}
.feedbackButton {
  color: var(--primary-color) !important;
}
.content {
  padding-top: 60px;
  height: 95vh;
  min-width: 100vw;
  overflow: scroll;
}
.feedback-text {
  padding-left: 0;
  color: black;
  font-size: 22px;
  font-weight: 700;
  padding-left: 0 !important;
  padding-bottom: 20px;
}
.bold-subtitle {
  font-weight: 700 !important;
  font-size: 15px;
}
.radio-input {
  color: var(--primary-color) !important;
}
.regular-font {
  font-size: 12px;
}
.continue-btn {
  background-color: var(--secondary-color) !important;
  color: var(--primary-color) !important;
  position: absolute;
}
.cor-secundaria {
  color: var(--secondary-color) !important;
}
</style>
